module.exports = __webpack_public_path__ + "media/pricing/usd-circle-regular-c7fb9797.png";